import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Menu,
  Container,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Header,
  Grid,
  Sidebar,
  Icon,
} from "semantic-ui-react";

import { CSVLink } from "react-csv";
import "./index.css";

const ListSalesData = ({
  currency,
  componentData,
  percentage,
  user_type = "",
  selected_dates,
}) => {
  const [dayWiseData, setDayWiseData] = useState([]);
  const { header, data } = componentData;
  const { headers } = data;

  const csvData = () => {
    let csvData = [];
    let values = data.values || [];
    for (var i = 0; i < values.length; i++) {
      let item = values[i]["values"];
      csvData.push(item);
    }
    return csvData;
  };

  console.log("selected_dates", selected_dates);

  async function fetchDaywiseAnalytics(type = "oscar_dashboard") {
    const url = "https://dashboard.oscar.pk/api/analytics/daywise/";
    const params = {
      start_date: selected_dates.start_date,
      end_date: selected_dates.end_date,
      type: type,
    };

    try {
      const response = await axios.get(url, { params });
      console.log("Response", response.data);
      setDayWiseData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
      return null;
    }
  }

  const displayValue = (value, displayCurrency = "", percentage = "") => {
    if (value == undefined || value <= 0 || value == "No Sales") {
      return "-";
    }

    return displayCurrency + " " + value + " " + percentage;
  };

  useEffect(() => {
    if (selected_dates) {
      fetchDaywiseAnalytics();
    }
  }, [selected_dates]);

  return (
    <Grid.Column verticalAlign="top">
      <Grid.Row style={styles.heading}>
        <Grid.Column textAlign="left" style={styles.salesbyStoreTopSec}>
          <Header as="h5" style={styles.headingText}>
            {header}
          </Header>
        </Grid.Column>
        <Grid.Column textAlign="right" style={styles.salesecRight}>
          {selected_dates ? (
            dayWiseData &&
            dayWiseData.data &&
            dayWiseData.data.length > 0 && (
              <Dropdown
                text={"Sales"}
                pointing="right"
                style={{ color: "#666874", fontFamily: "Roboto" }}
              >
                <DropdownMenu>
                  <DropdownItem>
                    <CSVLink
                      filename={`${header}.csv`}
                      headers={headers}
                      // target="_blank"
                      data={csvData()}
                    >
                      Aggregated sales
                    </CSVLink>
                  </DropdownItem>
                  <DropdownItem>
                    <CSVLink
                      filename={`${header}.csv`}
                      headers={dayWiseData.headers}
                      // target="_blank"
                      data={dayWiseData.data}
                    >
                      Day wise sales
                    </CSVLink>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            )
          ) : (
            <CSVLink
              filename={`${header}.csv`}
              headers={headers}
              // target="_blank"
              data={csvData()}
            >
              <Icon name="download" color="black" type="font-awesome" />
            </CSVLink>
          )}
        </Grid.Column>
      </Grid.Row>
      {/* <div className="margin-by-store"> */}
      <Grid>
        <Grid.Row style={styles.listMain}>
          <Grid.Column style={styles.subHeadingText} textAlign="left" width={4}>
            Store
          </Grid.Column>
          <Grid.Column
            style={styles.subHeadingText}
            textAlign="center"
            width={4}
          >
            Net Sales
          </Grid.Column>
          <Grid.Column
            style={styles.subHeadingText}
            textAlign="center"
            width={4}
          >
            Gross Margin(Rs.)
          </Grid.Column>
          <Grid.Column
            style={styles.subHeadingText}
            textAlign="center"
            width={4}
          >
            Gross Margin (%)
          </Grid.Column>
        </Grid.Row>
      </Grid>
      {/* </div> */}

      <div className="margin-by-store">
        {data.values.map((item, index) => {
          return (
            <Grid key={index}>
              <Grid.Row style={styles.listMainBody}>
                <Grid.Column style={styles.textIner} textAlign="left" width={4}>
                  {item.values[user_type == "shell_head_office" ? 5 : 0]}
                </Grid.Column>
                <Grid.Column
                  textAlign="center"
                  width={4}
                  style={styles.valueIner}
                >
                  {displayValue(
                    item.values[user_type == "shell_head_office" ? 6 : 1]
                  )}
                </Grid.Column>
                <Grid.Column
                  textAlign="center"
                  width={4}
                  style={styles.valueIner}
                >
                  {displayValue(
                    item.values[user_type == "shell_head_office" ? 7 : 2]
                  )}
                </Grid.Column>
                <Grid.Column
                  textAlign="center"
                  width={4}
                  style={styles.valueIner}
                >
                  {displayValue(
                    item.values[user_type == "shell_head_office" ? 8 : 3]
                  )}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          );
        })}
      </div>
    </Grid.Column>
  );
};

const styles = {
  heading: {
    color: "#af2d2d",
    borderBottom: "1px solid #c1c1c5",
    marginBottom: 20,
    marginLeft: 0,
    marginRight: 0,
  },
  headingText: {
    fontSize: 16,
    fontWeight: 400,
    color: "#666874",
    paddingBottom: 20,
    paddingLeft: 5,
    textTransform: "uppercase",
    fontFamily: "Roboto",
  },
  subHeadingText: {
    fontSize: 13,
    color: "#666874",
    // paddingBottom: 20,
    // paddingLeft: 20,
    fontWeight: 400,
    textTransform: "uppercase",
    fontFamily: "Roboto",
    textShadow: "none",
  },

  listMain: {
    borderStyle: "solid",
    borderBottomWidth: 1,
    borderBottomColor: "#f2f2f6",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-around",
    alignSelf: "center",
    marginBottom: 20,
    // paddingTop: 20,
    // paddingBottom: 20,
    paddingLeft: 0,
    paddingRight: 0,
    marginLeft: 15,
    marginRight: 15,
  },
  listMainBody: {
    borderStyle: "solid",
    borderBottomWidth: 1,
    borderBottomColor: "#f2f2f6",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-around",
    alignSelf: "center",
    // marginBottom: 20,
    // paddingTop: 20,
    // paddingBottom: 20,
    paddingLeft: 0,
    paddingRight: 0,
    marginLeft: 15,
    marginRight: 15,
  },
  valueIner: {
    fontSize: 13,
    fontWeight: 400,
    color: "#575757",
    fontFamily: "Roboto",
  },
  textIner: {
    fontSize: 13,
    fontWeight: 300,
    color: "#999999",
    fontFamily: "Roboto",
    textTransform: "capitalize",
  },
  values: {
    paddingTop: 10,
    // maxHeight:'370px',
    // overflowY:'scroll',
    // overflowX:'hidden',
    paddingBottom: 10,
    marginBottom: 30,
    height: 330,
    minHeight: 330,
    fontFamily: "Roboto",
    borderStyle: "solid",
    flexDirection: "row",
    justifyContent: "space-around",
    borderTopWidth: 1,
    borderTopColor: "#c1c1c5",
    textTransform: "capitalize",
  },
  salesbyStoreTopSec: {
    width: "50%",
  },
  salesecRight: {
    textAlign: "right",
    float: "right",
    width: "50%",
  },
};

export default ListSalesData;



// WEBPACK FOOTER //
// ./src/components/ListSalesData/index.js